module.exports = __webpack_public_path__ + "static/media/sf-roof.92bf0dca.jpg";